import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "fe_admin_token";

// Use sessionStorage so tokens are cleared when the tab closes (tighter than localStorage).
// Wrap in try/catch because sessionStorage may be unavailable in some sandboxed contexts.
const safeStorage = {
    get(key) {
        try { return sessionStorage.getItem(key); } catch { return null; }
    },
    set(key, val) {
        try { sessionStorage.setItem(key, val); } catch { /* noop */ }
    },
    remove(key) {
        try { sessionStorage.removeItem(key); } catch { /* noop */ }
    },
};

export const getToken = () => safeStorage.get(TOKEN_KEY);
export const setToken = (t) => safeStorage.set(TOKEN_KEY, t);
export const clearToken = () => safeStorage.remove(TOKEN_KEY);

export const authHeaders = () => {
    const t = getToken();
    return t ? { Authorization: `Bearer ${t}` } : {};
};

export const api = axios.create({ baseURL: API });

// Public
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const submitVolunteer = (payload) => api.post("/volunteers", payload).then((r) => r.data);
export const fetchPublicStats = () => api.get("/stats").then((r) => r.data);

// Admin
export const adminLogin = (username, password) =>
    api.post("/admin/login", { username, password }).then((r) => r.data);
export const adminMe = () => api.get("/admin/me", { headers: authHeaders() }).then((r) => r.data);
export const adminDashboard = () =>
    api.get("/admin/dashboard", { headers: authHeaders() }).then((r) => r.data);
export const adminListMessages = () =>
    api.get("/admin/messages", { headers: authHeaders() }).then((r) => r.data);
export const adminMarkRead = (id) =>
    api.patch(`/admin/messages/${id}`, {}, { headers: authHeaders() }).then((r) => r.data);
export const adminDeleteMessage = (id) =>
    api.delete(`/admin/messages/${id}`, { headers: authHeaders() }).then((r) => r.data);
export const adminListVolunteers = () =>
    api.get("/admin/volunteers", { headers: authHeaders() }).then((r) => r.data);
export const adminUpdateVolunteer = (id, estado) =>
    api.patch(`/admin/volunteers/${id}`, { estado }, { headers: authHeaders() }).then((r) => r.data);
export const adminDeleteVolunteer = (id) =>
    api.delete(`/admin/volunteers/${id}`, { headers: authHeaders() }).then((r) => r.data);
